import IconButton from 'components/IconButton';
import callApi from 'lib/callApi';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import React, { useState } from 'react';

import BPAScanDetailModal from './BPAScanDetailModal';
import { BPAScan } from './types';

interface RowActionsProps {
  rowData: BPAScan;
}

const RowActions: React.FC<RowActionsProps> = ({ rowData }) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadReport = async () => {
    if (!rowData.report_available || !rowData.report_record_id) return;

    setIsDownloading(true);
    try {
      const response = await callApi(
        `/reports/${rowData.report_record_id}/download/`,
        'GET',
      );
      const signedUrl = response?.data?.signed_url;
      if (!signedUrl) {
        throw new Error('The report download link was not returned.');
      }
      const link = document.createElement('a');
      link.href = signedUrl;
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      link.remove();
      showSuccessToast('Report download started.');
    } catch (error) {
      const message =
        (error as { data?: { detail?: string } })?.data?.detail ||
        'Failed to download the BPA report.';
      showFailureToast(message);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      {/* gap-2 is Bootstrap 5 only; use inline style for BS4 compatibility */}
      <div
        className="text-nowrap d-flex align-items-center justify-content-end"
        style={{ gap: '0.5rem' }}
      >
        <IconButton
          id={`view-scan-${rowData.id}`}
          iconClass="fa fa-eye"
          size="sm"
          tooltip="View scan details"
          onClick={() => setIsDetailOpen(true)}
        />

        <IconButton
          id={`download-scan-${rowData.id}`}
          iconClass="fa fa-download"
          size="sm"
          tooltip={
            rowData.report_available
              ? 'Download report'
              : 'Report is not available'
          }
          onClick={handleDownloadReport}
          disabled={!rowData.report_available || isDownloading}
        />
      </div>

      {isDetailOpen && (
        <BPAScanDetailModal
          scan={rowData}
          onClose={() => setIsDetailOpen(false)}
        />
      )}
    </>
  );
};

export default RowActions;
